/* eslint-disable */
import {
  CloseIcon,
  Heading,
  IconButton,
  ModalBody,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
} from '@noahswap/uikit'
import { useTranslation } from '@noahswap/localization'
import styled from 'styled-components'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`
const ResetModal: React.FC<React.PropsWithChildren<any>> = ({ onDismiss, reset }) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()
  console.log('reset modal', reset)
  return (
    <ModalContainer title={t('')} $minWidth={isMobile ? '100%' : '418px'} $minHeight={'auto'}>
      <ModalHeader>
        <ModalTitle>
          <Heading>{t('noah607')}</Heading>
        </ModalTitle>
        <IconButton variant="text" onClick={onDismiss}>
          <CloseIcon width="24px" color="#000" />
        </IconButton>
      </ModalHeader>
      <ModalBody p="0 24px 24px 24px" width="100%">
        {/* 没池子显示noah608 */}
        <div style={{ lineHeight: '18px', fontSize: '14px' }}>{t(reset === 0 ? 'noah606' : 'noah608')}</div>
      </ModalBody>
    </ModalContainer>
  )
}

export default ResetModal
